<template>
  <div v-if="authenticated" id="account-bookings" class="pt-3">
    <b-container>
      <div v-if="user.role_id === 3">
        <h2>{{ $t('account.professionalCalendarDescription') }}</h2>
        <bookings-calendar></bookings-calendar>
      </div>
      <div v-else-if="user.role_id === 2">
        <h2>{{ $t('account.customerCalendarDescription') }}</h2>
        <bookings-calendar></bookings-calendar>
      </div>
    </b-container>
  </div>
  <div v-else>
    <b-alert variant="danger" show>
      {{ $t('account.accessDenied') }}
    </b-alert>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { frontEndDateFormat } from '@/util/date'

  /* Start of lazy load components config */
  import lazyLoadComponent from '@/util/lazy-load-component'
  import Preloader from '@/app/global/components/Preloader'
  // import SkeletonBox from '@/app/global/components/SkeletonBox'
  const lazyLoadOptions = {
    loading: Preloader,
    loadingData: {
      props: {
        width: '100%',
        height: '2rem'
      }
    }
  }
  /* End of lazy load components config */

  export default {
    name: 'account-bookings',
    components: {
      BookingsCalendar: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/calendar/BookingsCalendar')})
    },
    data () {
      return {
        errors: []
      }
    },
    // metaInfo: {
    //   title: 'Test',
    //   titleTemplate: '%s - Yay!',
    //   htmlAttrs: {
    //     lang: 'en',
    //     amp: true
    //   }
    // },
    computed: {
      ...mapGetters({
        user: 'account/user',
        authenticated: 'account/authenticated'
      }),
    },
    methods: {
      ...mapActions({
      }),
      frontEndDateFormat: frontEndDateFormat,
    },
    mounted () {
    },
    created () {
    },
    watch: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #account-bookings {
    padding-bottom: 5rem;
    background: #f0f0f0;
  }
</style>
